import axios from "axios";
import { toast } from "react-toastify";

export const cutName = (name, cut) => {
  const arrName = name.split("");
  const idx = name.indexOf(cut);
  if (idx >= 0) arrName.splice(idx, cut.length);
  return arrName.join("");
};

export const validateLang = (lang) => {
  const allowedLangs = ["en", "ua"];
  return allowedLangs.includes(lang) ? lang : "en";
};

export const reorganizeData = (products, categories) => {
  // Step 1: Build category structure with categoryId, categoryName, and empty products array
  const formattedCategories = categories.map((category) => ({
    categoryId: category._id,
    categoryName: category.name,
    products: [],
  }));

  // Step 2: Create a map for fast lookup by categoryId
  const categoryMap = {};
  formattedCategories.forEach((category) => {
    categoryMap[category.categoryId] = category;
  });

  // Step 3: Process products
  products.forEach((product) => {
    const { _id, variants, categoryId, ...rest } = product;

    // Convert variants object to array
    const variantArray = Object.entries(variants).map(([key, value]) => ({
      ...value,
      packageSize: key,
    }));

    // Build formatted product
    const formattedProduct = {
      productId: _id,
      categoryId,
      ...rest,
      variants: variantArray,
    };

    // Push product into corresponding category
    if (categoryMap[categoryId]) {
      categoryMap[categoryId].products.push(formattedProduct);
    }
  });

  // Step 4: Return the new structure
  return Object.values(categoryMap).filter(
    (category) => category.products.length > 0
  );
};

export const newSendMail = async (data) => {
  const today = new Date();
  const prefix =
    ("0" + today.getDate()).slice(-2) +
    ("0" + (today.getMonth() + 1)).slice(-2);
  const orderNr = prefix + "-" + Math.random().toString(16).slice(7);

  const {
    subtotal,
    taxGST,
    taxPST,
    delivery,
    total,
    order,
    storeEmail,
    message,
    ...rest
  } = data;

  const dataToSend = {
    ...rest,
    orderNr,
    products: order.map((item) => ({
      id: item.productId,
      name:
        item.productName.en + " - " + item.option + " (" + item.weight + "g)",
      qty: item.qty,
      packageSize: item.packageSize,
      packageQty: item.option,
      packagePrice: item.price,
      packageWeight: item.weight || "",
    })),

    subtotal: "$" + Number(subtotal).toFixed(2),
    taxGST: "$" + Number(taxGST).toFixed(2),
    taxPST: "$" + Number(taxPST).toFixed(2),
    delivery: "$" + Number(delivery).toFixed(2),
    total: "$" + Number(total).toFixed(2),

    storeEmail: storeEmail || "order.multicookbrandon@gmail.com", // "0672182637@ukr.net",
    message: message || "",
  };
  try {
    // console.log(dataToSend);

    const response = await axios.post(
      "https://multicook-be.vercel.app/mail/order",
      //"http://localhost:8080/mail/order",
      dataToSend
    );
    console.log("Email sent successfully:", response.data);
    toast.success("Your order has been sent successfully!");
  } catch (error) {
    console.error("Error sending email:", error);
    toast.error("Error sending email: " + error.message);
  }
};

export const calculateOrderSummary = (
  cartList,
  storeId,
  defaultStoreId = "682b89f4c28a3e5c9c0ce408"
) => {
  // calculate raw numbers (numbers, not strings)
  const subtotalNum = cartList.reduce(
    (acc, curr) => acc + curr.price * curr.qty,
    0
  );

  const taxGSTNum = cartList.reduce((acc, curr) => {
    if (curr.taxGST) return acc + curr.price * curr.qty * 0.05;
    return acc;
  }, 0);

  const taxPSTNum = cartList.reduce((acc, curr) => {
    if (curr.taxGST) return acc + curr.price * curr.qty * 0.07;
    return acc;
  }, 0);

  const deliveryFreeRate = storeId === defaultStoreId ? 50 : 200;

  const deliveryFee = storeId === defaultStoreId ? 4.99 : 7.99;

  let delivery =
    subtotalNum + taxGSTNum + taxPSTNum >= deliveryFreeRate ? 0 : deliveryFee;
  const isFR = cartList.some((item) => item.packageSize === "fr");
  if (isFR) delivery = 0;

  const totalNum = subtotalNum + taxGSTNum + taxPSTNum + Number(delivery);

  // helper to round to 2 decimals (return number)
  const round2 = (v) => Math.round((v + Number.EPSILON) * 100) / 100;

  return {
    subtotal: round2(subtotalNum),
    taxGST: round2(taxGSTNum),
    taxPST: round2(taxPSTNum),
    delivery: round2(Number(delivery)),
    total: round2(totalNum),
  };
};
